var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-svg",class:_vm.display,domProps:{"innerHTML":_vm._s(_vm.inlineHtml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }